
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import { useState } from "react";
import { ReportForm } from "./ReportForm";
import { z } from "zod";

const reportFormSchema = z.object({
  title: z.string(),
  link: z.string().url(),
  table: z.enum(['reports', 'report_submissions']),
});

type ReportFormValues = z.infer<typeof reportFormSchema>;

interface AddReportDialogProps {
  onSubmit: (data: ReportFormValues) => void;
  disabled?: boolean;
}

export const AddReportDialog = ({ onSubmit, disabled }: AddReportDialogProps) => {
  const [open, setOpen] = useState(false);

  const handleSubmit = async (data: ReportFormValues) => {
    await onSubmit(data);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button 
          className="flex items-center gap-2 w-full md:w-auto px-3 text-center"
          disabled={disabled}
        >
          <Plus className="w-4 h-4 flex-shrink-0" />
          <span className="truncate">Create New Report</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[95vw] md:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Create New Report</DialogTitle>
          <DialogDescription>
            Fill out the form below to create a new report.
          </DialogDescription>
        </DialogHeader>
        <ReportForm onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
};
